<template>
    <div>
        <modalconfirm ref="modalconfirmVoucher" @action="processVoucher" />
        <div class="text-h5">Klaim Voucher</div>
        <v-card class="mt-3" outlined>
            <v-form ref="formVoucher" role="form">
                <v-card-text class="pt-2 pb-0">
                    <v-row class="flex-column">
                        <v-col cols="12" md="6" class="pb-0">
                            <v-text-field outlined dense v-model="mid" label="Kode Mitra" prepend-icon="mdi-card-account-details"
                                @focus="() => responseError.mid = ''" :error-messages="responseError.mid"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                            <v-text-field outlined dense v-model="voucher" label="Kode Voucher" prepend-icon="mdi-ticket-confirmation"
                                @focus="() => responseError.voucher = ''" :error-messages="responseError.voucher"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="px-4 pb-4 col-6 justify-end">
                    <v-btn light depressed color="primary" @click="submitCheckVoucher">
                        <v-icon>mdi-shield-check</v-icon>
                        <div class="pl-2 text-capitalize">Cek Voucher</div>
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-card class="mt-3" outlined v-if="checkVoucher">
            <v-form ref="formAdjustment" role="form">
                <v-card-text class="pt-2 pb-0">
                    <v-row class="flex-column">
                        <v-col cols="12" md="6" class="pb-0">
                            <v-select prepend-icon="mdi-sale" :items="promoList" item-value="value" item-text="label" label="Pilih Promo"
                                v-model="promo" class="py-3 details-mb-0" outlined dense background-color="white"
                                @focus="() => responseError.promo = ''" :error-messages="responseError.promo"></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="px-4 pb-4 col-6 justify-end">
                    <v-btn light depressed color="primary" @click="confirmClaimVoucher">
                        <v-icon>mdi-ticket</v-icon>
                        <div class="pl-2 text-capitalize">Klaim Voucher</div>
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </div>
</template>

<script>

import { mapActions, mapState, mapMutations } from 'vuex'

export default {
    inject: ['theme'],
    components: {
    },
    data() {
        return {
            mid: '',
            voucher: '',
            promo: 0,
            promoList: [
                {
                    label: 'Promo Tebus 1 MDW Rp. 250.000',
                    value: 1
                }, {
                    label: 'Promo Tebus 2 MDW Rp. 400.000',
                    value: 2
                }
            ],
            isLoading: false,
            sent: {
                mid: '',
                voucher: ''
            }
        }
    },
    computed: {
        ...mapState('voucher', ['voucherData', 'checkVoucher', 'responseError', 'response', 'alert']),
    },
    methods: {
        ...mapActions('voucher', ['getVoucher', 'claimVoucher']),
        ...mapMutations('voucher', ['saveResponse', 'setCheckVoucher']),
        ...mapMutations(['setOverlay', 'setSnackbar']),
        async submitCheckVoucher() {
            await this.setOverlay(true)
            let params = {
                mid: this.mid,
                code: this.voucher
            }
            await this.getVoucher(params).then(() => {
                if (this.response.code == 200) {
                    this.sent.mid = this.mid
                    this.sent.voucher = this.voucher
                }
            })
            await this.setOverlay(false)
        },
        confirmClaimVoucher() {
            if (this.promo > 0) {
                this.$refs.modalconfirmVoucher.setMessage('Apakah Anda yakin akan menggunakan voucher ini?')
                this.$refs.modalconfirmVoucher.showConfirm()
            } else {
                this.setSnackbar({
                    show: true,
                    color: 'red darken-2',
                    text: `Pilih promo terlebih dahulu`
                })
            }
        },
        async processVoucher() {
            await this.setOverlay(true)
            await this.$refs.modalconfirmVoucher.hideConfirm()
            let params = await {
                mid: this.sent.mid,
                code: this.sent.voucher,
                promo: this.promo,
            }
            await this.claimVoucher(params).then(() => {
                if (this.response.code == 200.) {
                    this.resetForm()
                }
            })
            await this.setOverlay(false)

        },
        resetForm() {
            this.saveResponse('')
            this.mid = ''
            this.voucher = ''
            this.sent.mid = ''
            this.sent.voucher = ''
            this.promo = 0
        },
    },
    created() {
        this.$store.dispatch('setPageTitle', `Klaim Voucher`)
    },
}
</script>